module.exports = __webpack_public_path__ + "img/gear-C-cogs_70x70.1240ea5c.png";